<template>
  <v-menu v-bind="computedMenuProps">
    <template v-slot:activator="{on}">
      <v-chip
        label
        class="zoox-component zoox-chip zoox-chip-dropdown"
        :disabled="disabled"
        :class="chipClasses"
        :color="appliedColor"
        :dark="selected"
        tabindex="0"
        v-on="on"
      >
        <z-icon
          v-if="icon"
          class="mr-1"
          :size="iconSize"
          :color="appliedIconColor"
          left
          >{{ icon }}
        </z-icon>
        <span
          class="zoox-chip-text"
          :class="{small, 'x-small': xSmall}"
          :style="{color: selected ? $zoox.colors.white : appliedColor}"
        >
          {{ valueText }}
        </span>

        <v-icon
          class="chip-dropdown-arrow-icon"
          :color="appliedIconColor"
          :size="iconSize"
        >
          $arrow_down
        </v-icon>
      </v-chip>
    </template>

    <v-list>
      <v-list-item
        v-for="item of items"
        :key="item.text"
        @click="onClickItem(item)"
      >
        {{ item.text }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import chipsMixin from '../chipsMixin'

/**
 * @displayName Chip Dropdown
 */
export default {
  name: 'ZChipDropdown',
  mixins: [chipsMixin],
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Selected value
     *
     * @modelName value
     */
    value: {
      type: [Number, String, Object],
      required: false,
      default: '',
    },
    /**
     * Options of dropdown
     *
     * @typedef Object {text:string,value:any}
     */
    items: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },

    /**
     * Altura máxima do menu
     */
    maxHeight: {
      type: [Number, String],
      default: 300,
    },
    /**
     * Props do menu
     */
    menuProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    valueText() {
      if (this.value && this.items.length) {
        const selectedOption = this.items.find(
          (item) => item.value === this.value
        )

        return selectedOption?.text || this.text
      }

      return this.text
    },

    computedMenuProps() {
      return {
        offsetY: true,
        contentClass: 'mt-2',
        maxHeight: this.maxHeight,
        ...this.menuProps,
      }
    },
  },
  methods: {
    onClickItem(item) {
      /**
       * Evento emitido ao selecionar um item
       *
       * @property {any} itemValue - Valor do item selecionado
       */
      this.$emit('change', item.value)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@scss/chips' as c;

.zoox-chip-dropdown {
  @include c.zoox-chip-base;
  position: relative;
}
</style>
